import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import { authService } from '../lib/api-service';
import { setToken } from '../lib/api';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

export default function MagicLinkVerify() {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    if (!uid || !token) {
      setStatus('error');
      return;
    }

    authService
      .verifyMagicLink(uid, token)
      .then((data) => {
        setToken(data.token);
        setStatus('success');
        // Redirect to home after a short delay
        setTimeout(() => {
          window.location.href = '/';
        }, 1500);
      })
      .catch(() => {
        setStatus('error');
      });
  }, [uid, token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8f8fa] px-4">
      <div className="w-full max-w-sm text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="mx-auto mb-4 h-12 w-12 animate-spin text-[var(--vivid-purple)]" />
            <p className="text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
              Se verifică link-ul...
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle2 className="mx-auto mb-4 h-12 w-12 text-green-500" />
            <h2 className="mb-2 text-xl font-bold" style={{ fontFamily: 'var(--font-primary)' }}>
              Conectat cu succes!
            </h2>
            <p className="text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
              Vei fi redirecționat automat...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="mx-auto mb-4 h-12 w-12 text-red-500" />
            <h2 className="mb-2 text-xl font-bold" style={{ fontFamily: 'var(--font-primary)' }}>
              Link invalid
            </h2>
            <p className="mb-6 text-sm text-muted-foreground" style={{ fontFamily: 'var(--font-secondary)' }}>
              Link-ul a expirat sau a fost deja folosit.
            </p>
            <button
              onClick={() => navigate('/cont')}
              className="inline-block rounded-lg bg-[var(--vivid-purple)] px-6 py-2.5 text-sm font-semibold text-white"
              style={{ fontFamily: 'var(--font-primary)' }}
            >
              Înapoi la cont
            </button>
          </>
        )}
      </div>
    </div>
  );
}
